import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { AssetsComponent } from './components/assets/assets.component';
import { CustomerDetailsComponent } from './customerDetails/customerDetails.component';
import { DevicesComponent } from './components/devices/devices.component';
import { UsersComponent } from './components/users/users.component';
import { AssetSensorMappingComponent } from './components/assetSensorMapping/assetSensorMapping.component';
import { EnvironmentComponent } from '../customer/components/master/components/environment/environment.component';
import { ExcursionComponent } from '../customer/components/master/components/excursion/excursion.component';
import { IncidentsComponent } from './components/incidents/incidents.component';
import { RolesComponent } from '../customer/components/master/components/roles/roles.component';
import { SensorTypeComponent } from '../customer/components/master/components/sensor-type/sensor-type.component';
import { ReportsComponent } from './components/reports/reports.component';
// import { LocationManagmentComponent } from './components/locationManagment/locationManagment.component';
import { GatewayManagementComponent } from './components/devices/components/gateway/gateway.component';
import { SensorManagementComponent } from './components/devices/components/sensor/sensor.component';
import { StorageSensorManagementComponent } from './components/devices/components/sensor/storage-sensor-management.component';
import { TransportSensorManagementComponent } from './components/devices/components/sensor/transport-sensor-management.component';
import { HooterManagementComponent } from './components/devices/components/hooter/hooter.component';
import { MissingReportsFormComponent } from './components/reports/component/missingReportsForm/missingReportsForm.component';
import { MasterComponent } from './components/master/master.component';
import { GroupManagementComponent } from './components/group-management/group-management.component';
import { ChecklistMasterComponent } from './components/master/components/checklist/checklist-master.component';
import { CustomerCapabilityComponent } from './components/master/components/customer-capability/customer-capability.component';
import { CustomerFeaturesComponent } from './components/customer-features/customer-features.component';
import { FeatureFormComponent } from './components/customer-features/feature-form/feature-form.component';


const routes: Routes = [
  {
    path: '',
    component: CustomerDetailsComponent,
    pathMatch: 'prefix',
    children: [
      { path: '', redirectTo: 'assets', pathMatch: 'full' },
      // { path: 'gateway-management', component: GatewayManagementComponent },
      // { path: 'sensor-management', component: SensorManagementComponent },
      // { path: 'hooter-management', component: HooterManagementComponent },
    ],
  }
];
@NgModule({
  declarations: [
    CustomerDetailsComponent,
    AssetsComponent,
    DevicesComponent,
    UsersComponent,
    AssetSensorMappingComponent,
    EnvironmentComponent,
    ExcursionComponent,
    IncidentsComponent,
    RolesComponent,
    SensorTypeComponent,
    ReportsComponent,
    // LocationManagmentComponent,
    GatewayManagementComponent,
    SensorManagementComponent,
    StorageSensorManagementComponent,
    TransportSensorManagementComponent,
    HooterManagementComponent,
    MissingReportsFormComponent,
    MasterComponent,
    GroupManagementComponent,
    ChecklistMasterComponent,
    CustomerCapabilityComponent,
    CustomerFeaturesComponent,
    FeatureFormComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes)
  ],
  exports: []
})
export class CustomerModule { }
